import bb from 'blingblingjs';
import {heightAuto, height0} from './transition-height-auto';

// Define State
let state = {
	menuOpen 		: false,
	//openMenuItems	: new Set
	openMenuItem 	: false,
	searchboxHasInputValue : false
}


// Define DOM Elements
const toggleBtn 		= bb('.js-fn_menuToggle');
const openBtn 		 	= bb('.js-fn_menuOpen');
const closeBtn 		 	= bb('.js-fn_menuClose');
const menu 			 	= bb('.js-el_menu')[0];
const menuItemToggle 	= bb('.js-fn__toggle-mobile-nav-item');
const menuItems 		= bb('.js-el__mobile-nav-item');
const container			= bb('.js-el__header')[0];
const searchbox			= bb('.js-el__search-input', menu)[0];
const scrollLock        = new ScrollLock(container);


// Event Functions
const openMenu = () => {
	state.menuOpen = true;
	update();
}

const closeMenu = () => {
	state.menuOpen = false;
	update();
}

const toggleMenu = () => {
	state.menuOpen = state.menuOpen ? false : true;
	update();
}

const toggleMenuItem = (e) => {
	const name = e.currentTarget.dataset.name;
	//state.openMenuItems.has(name) ? state.openMenuItems.delete(name) : state.openMenuItems.add(name)
	state.openMenuItem = state.openMenuItem == name ? false : name;
	update();
}

const searchboxHasInputValue = () => {

	if(searchbox.value) {
		state.searchboxHasInputValue = true;
	} else {
		state.searchboxHasInputValue = false;
	}
	update();
}


// Bind Events 
openBtn.on('click', openMenu);
closeBtn.on('click', closeMenu);
toggleBtn.on('click', toggleMenu);
menuItemToggle.on('click', toggleMenuItem);
searchbox.on('input', searchboxHasInputValue)

function ScrollLock(container) {
	let body = document.body;
	function enable() {
		body.style.overflow = "hidden";
		container.style.overflow = "hidden";
	}
	function disable() {
		body.style.overflow = "";
		container.style.overflow = "";
	}
	return {disable, enable};
}

// Update Function
function update(){
	let body = document.body;
	// Menu open / closed
	if(state.menuOpen == true) {
		scrollLock.enable();
		menu.classList.add('--is-open');
		container.classList.add('--has-open-mobilenav');
		body.classList.add('--has-open-mobilenav');
	} else {
		scrollLock.disable();
		menu.classList.remove('--is-open');
		container.classList.remove('--has-open-mobilenav');
		body.classList.remove('--has-open-mobilenav');
	}
	

	menu.classList.toggle('--search-has-value', state.searchboxHasInputValue)
	

	// Menu items open / closed 
	menuItems.forEach(el => {
		const name = el.dataset.name;
		const contentEl = bb('.header__mobile-nav__menuitem__links', el)[0]
		if(state.openMenuItem == name){
            el.classList.add('--is-open');
            heightAuto(contentEl);
        } else {
            el.classList.remove('--is-open');
            height0(contentEl)
        }
	})

} 
